import React from "react";

import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from "react-bootstrap";

import { NavLink } from "react-router-dom";

import { FaCartPlus, FaFacebookF, FaInstagram, FaPinterest, FaTwitter, FaYoutube, FaCheck, FaSketch, FaOpencart } from "react-icons/fa";
import { BsSendCheck, BsFill1CircleFill, BsFill2CircleFill, BsFill3CircleFill, BsFill4CircleFill, BsFill5CircleFill, BsCheckLg, BsFillPatchCheckFill, BsClipboardCheck } from "react-icons/bs";

function HowToPurchase() {

    return (

        <Container>

            <br/>

            <h3><strong><FaCartPlus /> ขั้นตอนการซื้อ</strong></h3>
       
            <h3 className="pb-3 border-bottom"></h3>
            <br/>
            {/* <h4 style={{fontSize:80, color: 'black'}}>❝</h4> */}

            <p style={{marginTop: 5}}>(1) เลือกหนังสือที่ต้องการซื้อเพื่อเข้าสู่หน้ารายละเอียดสินค้า
            <br/>(2) ในหน้ารายละเอียดสินค้า เลือกปุ่ม “ซื้อ Ebook” หรือปุ่ม “แชทกับร้านค้า”
            <br/>(3) ส่งหลักฐานการชำระเงินทางช่องทางเพจ Facebook – "Chic Chic Code of Law for You ประมวลกฎหมายฉบับ EBOOK"
            <br/>(4) ผู้ใช้งานจะได้รับ Coupon Code เพื่อใช้งาน ในหน้ารายละเอียดสินค้า
            <br/>(5) หลังจากใช้งาน Coupon Code แล้ว จะสามารถอ่านหนังสือดังกล่าวผ่านแอพพลิเคชั่น EduLaw (ios) ซึ่งสามารถอ่านหนังสือ Ebook ได้ทั้งในระบบออนไลน์และออฟไลน์
            </p>



            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
           
            

        </Container>

    );

}

export default HowToPurchase;